import React, {Component} from 'react';
import InfiniteCarousel from 'react-leaf-carousel';

class Carousel extends Component {

  setFrontImgLocal = (event) => {
    const {onClick} = this.props;
    onClick(event.target.getAttribute('customsrc'));
  }

  mappedImgs = () => {
    const {imgs, imgsMapped, cartelaVertical} = this.props;
    let auxOr, auxMap;
    if(cartelaVertical){
      auxOr = 1;
      auxMap = imgsMapped[auxOr];
    }else{
      auxOr = 0;
      auxMap = imgs;
    }
    return auxMap.map((element, index) => (<div key={Math.random()}>
      <img alt='' customsrc={imgsMapped[auxOr][index]} src={element} onClick={this.setFrontImgLocal} style={{
          cursor: 'pointer'
        }}/>
    </div>));
  };

  render() {
    const {cartelaVertical} = this.props;
    let selectedBreakpoints;
    if (cartelaVertical){
      selectedBreakpoints =[
      {
        breakpoint: 534,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 756,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 978,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1422,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 1644,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 1866,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 7
        }
      }
    ];
    } else {
      selectedBreakpoints = [
        {
          breakpoint: 386,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 463,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 916,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 1067,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }, {
          breakpoint: 1218,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }, {
          breakpoint: 1369,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        }, {
          breakpoint: 1520,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 7
          }
        }, {
          breakpoint: 1671,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 8
          }
        }
      ];
    }
    return (<InfiniteCarousel breakpoints={selectedBreakpoints} incrementalSides={true} dots={true} showSides={false} sideSize={0} sidesOpacity={1} slidesToScroll={8} slidesToShow={8} slidesSpacing={14} scrollOnDevice={true}>

      {this.mappedImgs()}

    </InfiniteCarousel>);
  }
}

export default Carousel;
